module.exports = __webpack_public_path__ + "static/media/TWI CAROUSEL 04.74e0d0be.jpg";